import React from "react";
import Feedback from "../assets/img/logo5.png";
import Product from "../assets/img/logo2.png";
import Consulatation from "../assets/img/logo1.png";
import Shipping from "../assets/img/logo4.png";
import Relationship from "../assets/img/logo6.png";
import Quality from "../assets/img/logo3.png";

const contentSteps = [
  {
    title: "Initial Consultation",
    details: [
      "Engage with clients to understand their specific needs and requirements.",
      "Discuss product customization options and bulk order details.",
    ],
    icon: Consulatation,
  },
  {
    title: "Product Selection and Customization",
    details: [
      "Offer a diverse range of pet nutrition products including customized meals, herbal supplements, and eco-friendly packaging options.",

      "Collaborate closely with clients to finalize recipes, packaging designs, and product specifications.",
    ],
    icon: Product,
  },
  {
    title: "Quality Assurance",
    details: [
      "Source premium materials for production.",
      "Implement rigorous quality control checks to ensure each product meets high standards.",
    ],
    icon: Quality,
  },

  {
    title: "Logistics and Shipping",
    details: [
      "Manage logistics to ensure safe and timely shipment of products.",
      "Utilize reliable shipping partners to deliver orders worldwide.",
    ],
    icon: Shipping,
  },
  {
    title: "Client Support and Feedback",
    details: [
      "Provide continuous support to clients throughout the process.",
      "Encourage feedback to improve products and services.",
    ],
    icon: Feedback,
  },
  {
    title: "Ongoing Relationship",
    details: [
      "Foster long-term relationships with clients by consistently delivering high-quality products.",
      "Adapt and evolve based on market trends and client needs.",
    ],
    icon: Relationship,
  },
];

const HowItWorks: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-center py-12 mt-10">
      {/* Heading Section */}
      <h2 className="text-5xl font-bold text-center mb-10">
        <span className="text-[#f98715]">How </span>
        <span className="text-black">It Works?</span>
      </h2>

      {/* Content Section */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-6xl px-4">
        {contentSteps.map((step, idx) => (
          <div
            key={idx}
            className="group bg-blue-50 shadow-md rounded-lg p-4 flex flex-col items-center text-center transition-all duration-300 overflow-hidden"
          > */}
      {/* Logo */}
      {/* <div className="w-16 h-16 bg-gray-400 rounded-full flex items-center justify-center mb-2">
              <img src={step.icon} alt={step.title} className="w-8 h-8" />
            </div> */}

      {/* Step Title */}
      {/* <h3 className="text-lg font-bold text-gray-800 mb-2">
              {idx + 1}. {step.title}
            </h3> */}

      {/* Details */}
      {/* <ul
              className="text-gray-700 text-sm space-y-2 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[1000px] group-hover:py-2 transition-all duration-300"
            >
              {step.details.map((detail, i) => (
                <li key={i}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div> */}
      {/* Content Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 w-full max-w-6xl px-4">
        {contentSteps.map((step, idx) => (
          <div
            key={idx}
            className="group  p-4 flex flex-col items-center text-center transition-all duration-300 overflow-hidden"
          >
            {/* Logo */}
            <div className="w-full h-52 flex items-center justify-center mb-2">
              <img src={step.icon} alt={step.title} className="" />
            </div>

            {/* Step Title */}
            {/* <h3 className="text-lg font-bold text-gray-800 mb-2">
              {idx + 1}. {step.title}
            </h3> */}

            {/* Details */}
            <ul className="text-gray-700 text-sm space-y-0 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[1000px] group-hover:py-2 transition-all duration-300">
              {step.details.map((detail, i) => (
                <li key={i}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
